import React, { Fragment, Suspense } from "react";
import { metaTag } from "../Library/commomLib";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
const TableComponent = React.lazy(() => import("../Components/RootComponents/TableComponent"));
const TablePage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <TableComponent />
      </Suspense>
    </Fragment>
  );
};

export default TablePage;
